/**
 * Created by Alican Köker on 2019-01-22.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {TimelineLite} from "gsap";
import {EdisonGameConfig} from "../../EdisonGameConfig";
import {EdisonSoundConfig} from "../../EdisonSoundConfig";

export class EdisonRandomFeatureIntro extends BaseView {

    private _layer:ScalableLayer;

    private _spineBuggsy:PIXI.spine.Spine;
    private _spineBetty:PIXI.spine.Spine;

    private _introPlayed:boolean = false;

    private _style:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontWeight : FontWeight.SEMI_BOLD,
        fontStyle : FontStyle.ITALIC,
        fontSize : "70px",
        fill : [
            "#ffff00",
            "#33CC00"
        ],
        stroke : "#99ff00",
        strokeThickness : 2,
        align : "center",
        lineJoin : "round",
        dropShadow : true,
        dropShadowAngle : 90 * PIXI.DEG_TO_RAD,
        dropShadowBlur : 8,
        dropShadowDistance : 3,

    };

    constructor() {
        super();

        this._layer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.RANDOM_FEATURE_INTRO.name);
    }

    protected initAnimations?():void {
        this._spineBuggsy = new PIXI.spine.Spine(GameResources.getSpineAsset("bugsyGold"));
        this._spineBetty = new PIXI.spine.Spine(GameResources.getSpineAsset("bettyGold"));
        this._layer.addChild(this._spineBuggsy);
        this._layer.addChild(this._spineBetty);
        this._spineBuggsy.scale.set(1.02, 1.02);
        this._spineBetty.scale.set(1.02, 1.02);
    }


    public playIntro(featureSym:string):void {
        this._introPlayed = false;

        const animationName:string = featureSym === "M1" ? "FlipBug" : "FlipBet";

        let tl:TimelineLite = new TimelineLite();

        tl.add(() => {
            SlotGame.sound.playEffect(featureSym === "M1" ? EdisonSoundConfig.instance.BUGSY_INTRO : EdisonSoundConfig.instance.BETTY_INTRO);
        });

        tl.add(() => {
            SlotGame.sound.playEffect(EdisonSoundConfig.instance.BETTY_BUGSY_INTRO_CLOSE);
        }, 1.73);


        const trackEntry:PIXI.spine.core.TrackEntry = featureSym === "M1" ?
            this._spineBuggsy.state.setAnimation(0, animationName, false) :
            this._spineBetty.state.setAnimation(0, animationName, false);
        trackEntry.timeScale = 1;
    }

    protected stopPresentation(closeCallback?:() => void):void {
        this._layer.removeChild(this);
        if(closeCallback) {
            closeCallback();
        }
    }

    public hideIntro():void {
        //this._layer.visible = false;
    }

    protected onResize?(resizeData:IResizeData):void {


        if(resizeData.orientation === Orientation.LANDSCAPE) {
            this._spineBuggsy.position.set(636, 326);
            this._spineBetty.position.set(636, 326);
        } else {
            this._spineBuggsy.position.set(634, 221);
            this._spineBetty.position.set(634, 221);
        }
    }
}